// Generic Coverage that let define the type of coverage
export interface BaseCoverage<T extends BaseCoverageType> {
  isEnabled: boolean;
  type: T;
  value: number;
  deductible?: number;
}

// Coverage type can be either homeCoverageType or carCoverageType
export type BaseCoverageType = HomeCoverageType | CarCoverageType;

// Home coverage is a base coverage with home coverage types
export type HomeCoverage = BaseCoverage<HomeCoverageType>;

// Car coverage is a base coverage with car coverage types
export type CarCoverage = BaseCoverage<CarCoverageType>;

// Coverages can be either HomeCoverage or CarCoverage
export type Coverage = HomeCoverage | CarCoverage;

export enum HomeCoverageType {
  // Base Home coverages
  AboveGroundWater = 'aboveGroundWater',
  AdditionnalLivingCost = 'additionnalLivingCost',
  Burglary = 'burglary',
  Fire = 'fire',
  IdentityTheft = 'identityTheft',
  MedicalExpenses = 'medicalExpenses',
  PersonalLiability = 'personalLiability',
  PersonalProperty = 'personalProperty',
  VoluntaryProperty = 'voluntaryProperty',
  WaterPackage = 'waterPackage',

  // Additional coverages for condo
  Betterments = 'bettermentsAndImprovements',
  ContingencyLiability = 'contingencyLiability',
  LossAssessmentProperty = 'lossAssessmentProperty',
  LossAssessmentLiability = 'lossAssessmentLiability',

  // Additional coverages for homeowner
  House = 'house',
  DetachedStructures = 'detachedStructures',
  Earthquakes = 'earthquakes',
  Wind = 'wind',
  FireAfterEarthquake = 'fireAfterEarthquake',
  WaterEntry = 'waterEntry',
  Pool = 'pool',
  Spa = 'spa',

  // Home deductible
  Deductible = 'deductible',
}

// To understand in which province each coverage is used (and which value to used), please refer yourself to
// https://docs.google.com/spreadsheets/d/1XfbtXl8H_-4UtakPPFBY_vP217KW_Qno-sUHZrgo2m8/edit#gid=0
// Please update the document when changes are made on coverages
export enum CarCoverageType {
  // Common
  ThirdLiability_A = 'thirdLiability_a', // Section A
  Collision_B2 = 'collision_b2', // Section B2
  Comprehensive_B3 = 'comprehensive_b3', // Section B3
  ChangeToDeductible_41 = 'changeToDeductible_41', // QEF 41
  TravelCosts_20a = 'travelCosts_20a', // QEF 20a
  NonOwnedVehicle_27 = 'nonOwnedVehicle_27', // QEF 27
  ReplacementCarValue_43ae = 'replacementCarValue_43ae', // QEF 43a-e
  RoadAssistance_33 = 'roadAssistance_33', // QEF 33
  RentOrLeased = 'rentOrLeased', // QEF 5a

  // Quebec
  AccidentBenefits_34 = 'accidentBenefits_34', // QEF 34
  LiabilityNonOwnedVehicle_2 = 'liabilityNonOwnedVehicle_2', // QEF 2

  // Ontario
  CollisionNotFault = 'collisionNotFault',
  FamilyProtection = 'familyProtection',
  UninsuredAutomobile = 'uninsuredAutomobile',
  // Ontario accident benefits
  IncomeReplacement = 'incomeReplacement',
  Caregiver = 'caregiver',
  DependentCare = 'dependentCare',
  Funeral = 'funeral',
  MedicalNonCatastrophicInjury = 'medicalNonCatastrophicInjury',
  MedicalCatastrophicInjury = 'medicalCatastrophicInjury',
  Indexation = 'indexation',
}
